(() => {
 function init(root) {
  if(root.dataset.snReady)return;
  const grid=root.querySelector('[data-sn-products]');
  const cards=[...grid.querySelectorAll('.sn-product')];
  const sort=root.querySelector('[data-sn-sort]');
  const size=root.querySelector('[data-sn-size]');
  const age=root.querySelector('[data-sn-age]');
  const reset=root.querySelector('[data-sn-reset]');
  if(!size||!age||!reset)return;
  root.dataset.snReady='true';
  const count=root.querySelector('[data-sn-count]');
  const original=count.textContent;
  const text=root.dataset;
  const collator=new Intl.Collator(document.documentElement.lang||'it',{numeric:true});
  const canonicalSize=value=>{const s=String(value||'').trim().toUpperCase().replace(/\s+/g,'');return ['TU','T.U.','T.U','UNICA','TAGLIAUNICA','ONESIZE','099'].includes(s)?'TU':s;};
  function ageInfo(value){
   const unknown={key:'na',label:text.snAgeUnknown,order:99999};
   if(root.dataset.snType==='scarpe')return unknown;
   const s=canonicalSize(value);
   if(s==='00M'||s==='000M')return unknown;
   let from,to;
   const m=s.match(/^(\d{1,2})(?:[-–/](\d{1,2}))?(M|MESI|MESE|A|ANNI|ANNO|Y)$/);
   if(m){const factor=['M','MESI','MESE'].includes(m[3])?1:12;from=Number(m[1])*factor;to=Number(m[2]||m[1])*factor;}
   else if(!['copertine','accessori'].includes(root.dataset.snType)&&/^(?:[1-9]|1[0-6])$/.test(s)){from=to=Number(s)*12;}
   else return unknown;
   const years=from>=24&&from%12===0&&to%12===0;
   const a=years?from/12:from,b=years?to/12:to;
   const unit=years?(a===b&&a===1?text.snYear:text.snYears):(a===b&&a===1?text.snMonth:text.snMonths);
   return {key:`${from}:${to}`,label:`${a===b?a:`${a}–${b}`} ${unit}`,order:from*1000+to};
  }
  const data=new Map(cards.map(card=>{let variants=[];try{variants=JSON.parse(card.querySelector('[data-sn-variants]')?.textContent||'[]');}catch(_){}return [card,variants.map(v=>({size:canonicalSize(v.size),available:v.available===true,age:ageInfo(v.size)}))];}));
  const ages=new Map();
  data.forEach(vs=>vs.filter(v=>v.available).forEach(v=>ages.set(v.age.key,v.age)));
  [...ages.values()].sort((a,b)=>a.order-b.order).forEach(v=>age.add(new Option(v.label,v.key)));
  function refreshSizes(){
   const selected=size.value;
   while(size.options.length>1)size.remove(1);
   const sizes=new Set();
   data.forEach(vs=>vs.filter(v=>v.available&&(!age.value||v.age.key===age.value)).forEach(v=>{if(v.size)sizes.add(v.size);}));
   [...sizes].sort(collator.compare).forEach(s=>size.add(new Option(s==='TU'?text.snSizeUnique:s,s)));
   size.value=sizes.has(selected)?selected:'';
  }
  function update() {
   const ordered=[...cards];
   if(sort.value!=='featured')ordered.sort((a,b)=>(Number(a.dataset.snPrice)-Number(b.dataset.snPrice))*(sort.value==='high'?-1:1));
   let visible=0;
   const fragment=document.createDocumentFragment();
   ordered.forEach(card=>{
    const vs=data.get(card);
    const selected=Boolean(age.value||size.value);
    const match=!selected||vs.some(v=>v.available&&(!size.value||v.size===size.value)&&(!age.value||v.age.key===age.value));
    card.hidden=!match;if(match)visible++;fragment.append(card);
   });
   grid.append(fragment);
   count.textContent=original.replace(/\d+/,String(visible));
   root.querySelector('[data-sn-empty]').hidden=visible>0;
   reset.disabled=!age.value&&!size.value;
  }
  refreshSizes();
  root.querySelector('[data-sn-controls]').hidden=false;
  root.querySelector('[data-sn-filter-help]').hidden=false;
  age.addEventListener('change',()=>{refreshSizes();update();});
  size.addEventListener('change',update);
  sort.addEventListener('change',update);
  reset.addEventListener('click',()=>{age.value='';size.value='';refreshSizes();update();});
 }
 document.querySelectorAll('[data-sn-category]').forEach(init);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-sn-category]').forEach(init));
})();
